import apiFetch from '../apiFetch'

export default function (idAlbaran) {
  return apiFetch({endPoint: `Albaran/eliminarAlbaran?idAlbaran=` + idAlbaran, method: 'GET', body: null})
}
